<template>
  <main
    class="main internet_create_preview_form"
    role="main"
    v-if="isCompleted"
  >
    <div class="main_con">
      <JoinInfo
        :item="internetCommerceApply"
        :shop="shop"
        :applyCreated="applyCreated"
        :isPromotionView="isPromotionView"
      />
      <div class="internet_join">
        <div class="internet_join_cont">
          <div class="j_section">
            <div class="af_title">
              <div class="txt_1">고객 가입 정보 (고객님 직접 입력)</div>
              <div class="txt_2"><span>*</span>필수 입력</div>
            </div>
            <div class="sect_cont">
              <div class="customer_join_info" v-if="isSubmitDetail">
                <!-- 개인정보 -->
                <ul>
                  <div class="title_wrap">개인정보</div>
                  <li>
                    <dl>
                      <dt>
                        이름 (본명)<span
                          class="aster"
                          :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="name"
                            :disabled="disabled"
                            maxlength="10"
                            v-model.trim="form.name"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.name.$error }">
                      이름을 입력해 주세요
                    </p>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        주민번호<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        ><span> (숫자만 입력)</span>
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="residentNumber"
                            placeholder="숫자만 입력"
                            :disabled="disabled"
                            maxlength="13"
                            v-model.trim="form.residentNumber"
                            @input="handleNumberInput('residentNumber')"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p
                      class="valid"
                      :class="{ on: $v.form.residentNumber.$error }"
                    >
                      {{ errorMessage.residentNumber }}
                    </p>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        휴대폰 번호<span
                          class="aster"
                          :class="{ on: !disabled }"
                          >*</span
                        ><span> (숫자만 입력)</span>
                      </dt>
                      <dd>
                        <div class="icMobileWrap" v-if="isPromotionView">
                          <div
                            class="icSelectTelecom"
                            @click="openTelecomModal"
                          >
                            <div class="boxTelecom">
                              <label class="input">
                                <input
                                  type="text"
                                  placeholder="통신사"
                                  :disabled="disabled"
                                  readonly
                                  v-model.trim="form.mobileTelecom"
                                />
                              </label>
                            </div>
                            <div class="boxArrow">
                              <img
                                :src="
                                  require(`@/assets/front/images/mobile/i_select.svg`)
                                "
                                alt=""
                              />
                            </div>
                          </div>
                          <div class="boxMobile">
                            <label class="input">
                              <input
                                type="text"
                                ref="mobileNumber"
                                placeholder="숫자만 입력"
                                :disabled="disabled"
                                maxlength="11"
                                v-model.trim="form.mobileNumber"
                                @input="handleNumberInput('mobileNumber')"
                              />
                            </label>
                          </div>
                        </div>
                        <div v-else>
                          <label class="input">
                            <input
                              type="text"
                              ref="mobileNumber"
                              placeholder="숫자만 입력"
                              :disabled="disabled"
                              maxlength="11"
                              v-model.trim="form.mobileNumber"
                              @input="handleNumberInput('mobileNumber')"
                            />
                          </label>
                        </div>
                      </dd>
                    </dl>
                    <p
                      class="valid"
                      :class="{ on: $v.form.mobileTelecom.$error }"
                    >
                      {{ errorMessage.mobileTelecom }}
                    </p>
                    <p
                      class="valid"
                      :class="{ on: $v.form.mobileNumber.$error }"
                    >
                      {{ errorMessage.mobileNumber }}
                    </p>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        설치주소<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd class="address">
                        <label class="input">
                          <textarea
                            style="color: black"
                            :style="{
                              padding: form.address ? '0.8rem 1rem' : '0',
                            }"
                            id="address"
                            ref="address"
                            :disabled="disabled"
                            :readonly="readonly"
                            v-model="form.address"
                            :rows="form.address ? 1 : 2"
                          />
                        </label>
                        <button
                          v-if="!isSubmit && applyMode == 'submit'"
                          @click="addressSearch"
                        >
                          주소검색
                        </button>
                      </dd>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            placeholder="상세주소"
                            :disabled="disabled"
                            maxlength="50"
                            v-model.trim="form.addressDetail"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.address.$error }">
                      주소를 입력해 주세요
                    </p>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        희망 설치일<span
                          class="aster"
                          :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <div class="icSelectBox">
                          <div class="boxDatepicker">
                            <datepicker
                              placeholder="날짜를 선택해주세요"
                              :highlighted="highlighted"
                              v-model="form.installDate"
                              :value="form.installDate"
                              :language="ko"
                              :format="datePickerFormat"
                              :open-date="openDate"
                              :disabledDates="disabledDates"
                              :disabled="disabled"
                            ></datepicker>
                          </div>
                          <div class="boxArrow">
                            <img
                              :src="
                                require(`@/assets/front/images/mobile/i_select.svg`)
                              "
                              alt=""
                            />
                          </div>
                        </div>
                      </dd>
                    </dl>
                    <p
                      class="valid"
                      :class="{ on: $v.form.installDate.$error }"
                    >
                      {{ errorMessage.installDate }}
                    </p>
                  </li>
                  <li v-if="form.email || !disabled">
                    <dl>
                      <dt>
                        이메일<span
                          v-if="!isPromotionView"
                          class="aster"
                          :class="{ on: !disabled }"
                          >*</span
                        >
                        <span v-if="isPromotionView"> (청구서 희망 시)</span>
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="email"
                            placeholder="예) perce@perce.kr"
                            maxlength="50"
                            :disabled="disabled"
                            v-model.trim="form.email"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.email.$error }">
                      {{ errorMessage.email }}
                    </p>
                  </li>
                </ul>
                <!-- 요금납부 정보 -->
                <ul>
                  <div class="title_wrap">
                    요금납부 정보<span> (자동이체)</span>
                  </div>
                  <div class="sub_txt">
                    인터넷 명의자와 납부자가 일치해야 합니다. 설치 후에는
                    고객센터를 통해 납부자를 변경하실 수 있습니다.
                  </div>
                  <div class="radio_box" v-if="!disabled">
                    <div class="radio">
                      <input
                        type="radio"
                        id="radio_1"
                        v-model="payType"
                        value="CARD"
                      />
                      <label for="radio_1">카드 결제</label>
                    </div>
                    <div class="radio">
                      <input
                        type="radio"
                        id="radio_2"
                        v-model="payType"
                        value="BANK"
                      />
                      <label for="radio_2">계좌 이체</label>
                    </div>
                  </div>
                  <!-- 카드결제 -->
                  <li v-if="payType === 'CARD'">
                    <dl>
                      <dt>
                        카드사<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="cardName"
                            :disabled="disabled"
                            maxlength="10"
                            v-model.trim="form.cardName"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.cardName.$error }">
                      카드사를 입력해 주세요
                    </p>
                  </li>
                  <li v-if="payType === 'CARD'">
                    <dl>
                      <dt>
                        카드주(카드명의)<span
                          class="aster"
                          :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="cardOwner"
                            :disabled="disabled"
                            maxlength="10"
                            v-model.trim="form.cardOwner"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.cardOwner.$error }">
                      {{ errorMessage.cardOwner }}
                    </p>
                  </li>
                  <li v-if="payType === 'CARD'">
                    <dl>
                      <dt>
                        카드번호<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="cardNumber"
                            maxlength="19"
                            :disabled="disabled"
                            v-model.trim="form.cardNumber"
                            @input="handleCardNumber"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.cardNumber.$error }">
                      카드번호를 입력해 주세요
                    </p>
                  </li>
                  <li v-if="payType === 'CARD'" style="margin-bottom: 2rem ">
                    <dl>
                      <dt>
                        카드 유효 기간<span
                          class="aster"
                          :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <div class="card_box">
                          <ul class="filter">
                            <li @click="openMonthModal">
                              <div class="r_select top_mg on">
                                <button
                                  ref="cardMonth"
                                  :style="{
                                    color:
                                      form.cardMonth && !disabled
                                        ? '#212121'
                                        : '#bdbdbd',
                                  }"
                                  :disabled="disabled"
                                >
                                  {{ form.cardMonth }}월<span
                                    class="i_drop"
                                  ></span>
                                </button>
                              </div>
                            </li>
                            <li class="slash">/</li>
                            <li @click="openYearModal">
                              <div class="r_select top_mg on">
                                <button
                                  ref="cardYear"
                                  :style="{
                                    color:
                                      form.cardYear && !disabled
                                        ? '#212121'
                                        : '#bdbdbd',
                                  }"
                                  :disabled="disabled"
                                >
                                  {{ form.cardYear }}년<span
                                    class="i_drop"
                                  ></span>
                                </button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </dd>
                    </dl>
                    <p
                      class="valid"
                      :class="{
                        on: $v.form.cardMonth.$error || $v.form.cardYear.$error,
                      }"
                    >
                      카드 유효 기간을 입력해 주세요
                    </p>
                  </li>
                  <!-- 계좌이체 -->
                  <li v-if="payType === 'BANK'">
                    <dl>
                      <dt>
                        예금주명<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="bankOwner"
                            :disabled="disabled"
                            maxlength="10"
                            v-model.trim="form.bankOwner"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.bankOwner.$error }">
                      {{ errorMessage.bankOwner }}
                    </p>
                  </li>
                  <li v-if="payType === 'BANK'">
                    <dl>
                      <dt>
                        은행명<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="bankName"
                            :disabled="disabled"
                            maxlength="10"
                            v-model.trim="form.bankName"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.bankName.$error }">
                      은행명을 입력해 주세요
                    </p>
                  </li>
                  <li v-if="payType === 'BANK'">
                    <dl>
                      <dt>
                        계좌번호<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="bankNumber"
                            placeholder="숫자만 입력"
                            :disabled="disabled"
                            maxlength="30"
                            v-model.trim="form.bankNumber"
                            @input="handleNumberInput('bankNumber')"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p class="valid" :class="{ on: $v.form.bankNumber.$error }">
                      계좌번호를 입력해 주세요
                    </p>
                  </li>
                </ul>
                <!-- 입금정보 -->
                <ul v-if="!isPromotionView">
                  <div class="title_wrap">
                    입금정보<span> (지원금수령용)</span>
                    <div
                      class="checkbox"
                      v-if="payType === 'BANK' && !disabled"
                    >
                      <input
                        type="checkbox"
                        id="equal_detail"
                        v-model="isSameInfo"
                      />
                      <label for="equal_detail">납부정보와 같음</label>
                    </div>
                  </div>
                  <li>
                    <dl>
                      <dt>
                        예금주명<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="supportBankOwner"
                            :disabled="disabled"
                            maxlength="10"
                            v-model.trim="form.supportBankOwner"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p
                      class="valid"
                      :class="{ on: $v.form.supportBankOwner.$error }"
                    >
                      {{ this.errorMessage.supportBankOwner }}
                    </p>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        은행명<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="supportBankName"
                            :disabled="disabled"
                            v-model.trim="form.supportBankName"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p
                      class="valid"
                      :class="{ on: $v.form.supportBankName.$error }"
                    >
                      {{ this.errorMessage.supportBankName }}
                    </p>
                  </li>
                  <li>
                    <dl>
                      <dt>
                        계좌번호<span class="aster" :class="{ on: !disabled }"
                          >*</span
                        >
                      </dt>
                      <dd>
                        <label class="input">
                          <input
                            type="text"
                            ref="supportBankNumber"
                            maxlength="30"
                            placeholder="숫자만 입력"
                            :disabled="disabled"
                            v-model.trim="form.supportBankNumber"
                            @input="handleNumberInput('supportBankNumber')"
                          />
                        </label>
                      </dd>
                    </dl>
                    <p
                      class="valid"
                      :class="{ on: $v.form.supportBankNumber.$error }"
                    >
                      {{ this.errorMessage.supportBankNumber }}
                    </p>
                  </li>
                </ul>

                <ul v-if="isPromotionView">
                  <div class="title_wrap">
                    상품권 선택
                  </div>
                  <div class="radio_box2">
                    <div class="radio mr">
                      <input
                        type="radio"
                        id="radio_gift_1"
                        v-model="form.giftOption"
                        value="이마트"
                        :disabled="disabled"
                      />
                      <label for="radio_gift_1" :class="{ disabled: disabled }"
                        >이마트</label
                      >
                    </div>
                    <div class="radio mr">
                      <input
                        type="radio"
                        id="radio_gift_2"
                        v-model="form.giftOption"
                        value="홈플러스"
                        :disabled="disabled"
                      />
                      <label for="radio_gift_2" :class="{ disabled: disabled }"
                        >홈플러스</label
                      >
                    </div>
                    <div class="radio mr">
                      <input
                        type="radio"
                        id="radio_gift_3"
                        v-model="form.giftOption"
                        value="롯데"
                        :disabled="disabled"
                      />
                      <label for="radio_gift_3" :class="{ disabled: disabled }"
                        >롯데</label
                      >
                    </div>
                    <div class="radio">
                      <input
                        type="radio"
                        id="radio_gift_4"
                        v-model="form.giftOption"
                        value="농협"
                        :disabled="disabled"
                      />
                      <label for="radio_gift_4" :class="{ disabled: disabled }"
                        >농협</label
                      >
                    </div>
                  </div>
                </ul>
                <p class="customer_join_info_p">
                  ※기입된 인적사항은 보름 후 비공개됩니다.
                </p>
                <p class="customer_join_info_p">
                  ※사장님이 신청서를 열람전에는 취소가 가능하며,<br />취소 시
                  작성된 개인정보는 즉시 폐기됩니다.
                </p>
              </div>
              <div class="customer_join_info_blind" v-else>
                <div>고객님의 인적사항은 비공개 전환되었습니다.</div>
                <br />
                <div>내용의 확인을 원하시면</div>
                <div>고객센터로 문의를 바랍니다.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="internet_join_cont">
          <div class="j_section">
            <div class="af_title">
              <div class="txt_1">필수 안내 사항</div>
            </div>
            <div class="sect_cont">
              <div class="essential_info" v-if="isPromotionView">
                <p>★ 인터넷 3년약정 기준</p>
                <p>
                  ★ 인터넷 설치 후 1년 이내(사용 일수) 해지 및 요금제 하향 시
                  사은품 100% 반환
                </p>
                <p>
                  ★ 인터넷 개통 후 기존 사용하시던 인터넷 회선은 고객이 직접
                  해지해야 함
                </p>
                <p>
                  ★ 기사 방문 시 설치 불가 또는 상품이 변경될 수 있으며, 변경된
                  요금제에 따라 할인
                </p>
                <p>
                  ★ 설치 후 일주일 이내 모바일 상품권 미 수신 시 채팅 문의 (3일
                  이내 재전송) - 미 수신 고객님은 스팸문자함 확인 바랍니다.
                </p>
                <p>
                  ★ 모바일 결합은 고객센터 또는 대리점으로 별도 요청 바랍니다.
                </p>
                <p>★ 인터넷 설치 시 설치비 별도</p>
              </div>
              <div class="essential_info" v-else>
                <p>★ 인터넷 3년약정 기준</p>
                <p>
                  ★ 인터넷 설치후 1년이내 (사용일수) 해지시 사은품 100% 반환
                </p>
                <p>
                  ★ 인터넷 개통후 기존 사용하시던 인터넷회선은 고객이 직접 해지
                  해야 함
                </p>
                <p>
                  ★ 기존 인터넷 해지를 자동으로 원하실 경우에는 반드시
                  판매자에게 해지여부 요청을 해야 함
                </p>
                <p>★ 인터넷 설치시 설치비 별도</p>
              </div>
            </div>
          </div>
          <div class="j_agree" v-if="!isSubmit && applyMode == 'submit'">
            <div class="checkbox" @click.stop="applyCk">
              <input
                type="checkbox"
                id="agree_checkbox"
                v-model="applyChecked"
              />
              <label for="agree_checkbox"
                >개인 정보 제3자 제공에 동의합니다.</label
              >
            </div>
            <p class="j_agree_p">
              ※기입하신 정보는 안전하게 보호되며, 해당 매장외는 공개되지
              않습니다.
            </p>
          </div>
        </div>
        <textarea name="apply_form" id="apply_form" v-model="formData" />
      </div>
    </div>
    <div class="btm_btn" v-if="!isSubmit && applyMode != 'detail'">
      <div class="btn_wrap">
        <button class="btn" @click="sendForm">
          전송하기
        </button>
      </div>
    </div>
    <div
      class="btm_btn"
      v-if="!isCustomer && isSubmit && isSubmitDetail && applyMode == 'detail'"
    >
      <div class="btn_wrap">
        <button class="btn" @click="copyForm" v-if="!hideInfo">
          내용 복사하기
          <div>(문자나 카톡 등에 붙여넣기 가능)</div>
        </button>
        <button
          v-else
          class="btn"
          @click="dupCheckInfo"
          :disabled="shopVouchersCnt === 0"
        >
          고객 전체정보 확인하기
        </button>
      </div>
    </div>
    <div
      class="btm_btn"
      @click="customerApplyCancelPopupOpen"
      v-if="
        isCustomer &&
          isSubmit &&
          isSubmitDetail &&
          applyMode == 'detail' &&
          shopVouchersLimit
      "
    >
      <div class="btn_wrap">
        <button class="btn">
          취소하기
        </button>
      </div>
    </div>
    <transition name="fade">
      <div
        class="made_toast_layer_common"
        style="position: fixed; bottom: 10%"
        v-if="isViewToast"
      >
        <div class="toast_msg">{{ message }}</div>
      </div>
    </transition>
    <AddressSearch
      ref="addressSearch"
      @close="closeAddressSearch"
    ></AddressSearch>
    <InternetApplyVoucher
      ref="internetApplyVoucher"
      @close="closeInternetApplyVoucherModal"
      @voucherUse="voucherUse"
      :shopVouchersCnt="shopVouchersCnt"
      :from="'form'"
    />
    <MonthModal
      ref="MonthModal"
      :show="isMonthModal"
      :month="form.cardMonth"
      @close="closeMonthModal"
    />
    <YearModal
      ref="YearModal"
      :show="isYearModal"
      :year="form.cardYear"
      @close="closeYearModal"
    />
    <TelecomModal
      ref="TelecomModal"
      :show="isTelecomModal"
      @close="closeTelecomModal"
    />
    <DesignPopup2
      :show="applyPopup"
      :data="{
        title: '가입 신청서 전송하기',
        type: 'confirm',
        msg: `${
          chatListType === 'IC'
            ? '신청서 전송 시 등록하셨던<br />\'견적 받아보기\'가 자동으로 종료되며,<br />기입하신 정보가 매장에 전달됩니다.<br /><br />'
            : ''
        }<span style='font-weight:500;font-size:1.5rem;'>${
          chatListType === 'IC'
            ? '진행하시겠습니까?'
            : '매장에 신청서를 전송할까요?'
        }</span><br /><br /><span
      style='color:#757575;font-size:1.5rem;'
      >※ 신청하신 내역은 ‘신청현황' 메뉴에서<br />조회 가능하며, 삭제가 불가합니다.<br />(보름 후 자동 비공개 전환)</span
    >`,
      }"
      @close="applyPopupClose"
    />
    <DesignPopup2
      :show="cusDupPopup"
      :data="{
        title: '한번 더 확인해보세요!',
        type: 'confirm',
        msg: `동일 명의로<br /><span style='font-weight:700;font-size:1.5rem;'>${dupList}</span>에<br />인터넷 신청서를 전송한 이력이 있습니다.<br /><br />중복 가입을 예방하기 위해 해당 정보는 상담 중인 모든 매장에 전달됩니다.`,
        btn_1: '취소',
        btn_2: '동의하고 전송하기',
      }"
      @close="cusDupPopupClose"
    />
    <DesignPopup2
      :show="ownerDupPopup"
      :data="{
        title: '한번 더 확인해보세요!',
        type: 'confirm',
        msg: `중복 가입을 예방하기 위해 전달드립니다.<br /><br />이 고객님은 동일 명의로<br /><span style='font-weight:700;font-size:1.5rem;'>${dupList}</span>에<br />인터넷 신청서를 전송한 이력이 있습니다.`,
        btn_1: '취소',
        btn_2: '확인하고 열람하기',
      }"
      @close="ownerDupPopupClose"
    />
    <DesignPopup2
      :show="customerApplyCancelNoPopup"
      :data="{
        title: '신청서 열람 불가 안내',
        type: 'alert',
        msg: `고객님이 인터넷 가입 신청을 취소하여 신청서 열람이 불가합니다.`,
        btn_1: '',
        btn_2: '확인',
      }"
      @close="customerApplyCancelNoPopupClose"
    />
    <DesignPopup2
      :show="customerApplyCancelPopup"
      :data="{
        title: '가입 신청 취소하기',
        type: 'confirm',
        msg: `고객님이 전송하신 신청서는 아직 매장에서 열람되지 않아 취소가 가능합니다.<br /><br /> 가입 신청을 취소하시겠습니까?<br /><br />확인을 누르시면 작성된 개인정보는 즉시 폐기됩니다.`,
        btn_1: '취소',
        btn_2: '확인',
      }"
      @close="customerApplyCancelPopupClose"
    />
    <DesignPopup2
      :show="alreadyVoucherOpenPopup"
      :data="{
        title: '가입 신청 취소하기',
        type: 'alert',
        msg: `사장님이 이미 신청서를 열람하였습니다.<br />사장님이 열람 후에는 즉시 취소가 불가합니다.<br /><br />작성된 개인정보는 취소하지 않아도<br />15일 후 자동폐기 됩니다.`,
        btn_1: '',
        btn_2: '확인',
      }"
      @close="alreadyVoucherOpenPopupClose"
    />
  </main>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import { default as format } from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { sleep, setMasking, setMaskingFirst } from '@common/lib/common/utils';
import { required } from 'vuelidate/lib/validators';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import AddressSearch from '@common/components/modal/AddressSearch';
import InternetApplyVoucher from '@/front/owner/views/chat/modal/InternetApplyVoucher';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';
import { mapActions as chatMapActions } from '@common/store/modules/chat';
import * as chatTypes from '@common/store/modules/chat/types';
import * as commonActions from '@common/store/modules/common/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';

import MonthModal from '@common/components/modal/MonthModal';
import YearModal from '@common/components/modal/YearModal';

import TelecomModal from '@common/components/internetCommerce/modal/TelecomModal';

import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';

import JoinInfo from '@common/components/internetCommerce/JoinInfo.vue';

export default {
  components: {
    AddressSearch,
    DesignPopup2,
    InternetApplyVoucher,
    MonthModal,
    YearModal,
    Datepicker,
    TelecomModal,
    JoinInfo,
  },
  data() {
    return {
      applyCreated: format(new Date(), 'yyyy-MM-dd'),
      disabled: false,
      readonly: false,
      isCompleted: false,
      applyPopup: false,
      internetCommerceApply: {},
      shopName: '',
      shopTelNumber: '',
      shopAddress: '',
      applyMode: this.$route.params.mode,
      applyChecked: false,
      jibunAddr: '',
      payType: 'CARD',
      form: {
        name: '',
        residentNumber: '',
        mobileNumber: '',
        address: '',
        addressDetail: '',
        email: '',
        bankOwner: '',
        bankName: '',
        bankNumber: '',
        cardName: '',
        cardOwner: '',
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        supportBankName: '',
        supportBankOwner: '',
        supportBankNumber: '',
        mobileTelecom: '',
        installDate: '',
        giftOption: '이마트',
      },
      isViewToast: false,
      isSubmit: false,
      isSubmitDetail: true,
      hideInfo: this.$route.params.hideInfo || false, // 사장님 주소 먼저 확인하기 에서 진입시 true
      applyType: this.$route.params.applyType || '',
      userId: this.$route.params.userId,
      applyId: this.$route.params.id,
      chatListType: this.$route.params.chatListType,
      storeId: this.$route.params.storeId || '',
      chatRoomId: this.$route.params.chatRoomId,
      promotionId: this.$route.params.promotionId || 0,
      shopVouchersCnt: 0,
      isValid: false,
      isSameInfo: false,
      isExpireDateModal: false,
      isMonthModal: false,
      isYearModal: false,
      isTelecomModal: false,
      message: '',
      errorMessage: {
        email: '',
        residentNumber: '',
        mobileTelecom: '',
        mobileNumber: '',
        installDate: '',
        cardOwner: '',
        supportBankName: '',
        supportBankOwner: '',
        supportBankNumber: '',
      },
      dupList: '', // 동일 명의로 인터넷 전송 이력 정보 ex) 24.05.06(SKT)
      ownerDupPopup: false,
      cusDupPopup: false,
      isPromotionView: false,
      datePickerFormat: 'M월 dd일 (D요일)',
      ko: ko,
      openDate: new Date(),
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      highlighted: {
        dates: [new Date()],
      },
      shopVouchersLimit: true,
      userApplyCancel: false,
      customerApplyCancelNoPopup: false,
      customerApplyCancelPopup: false,
      alreadyVoucherOpenPopup: false,
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...shopMapGetters({
      shop: shopTypes.SHOP,
      vouchersUseResult: shopTypes.SHOP_VOUCHERS_USE_RESULT,
    }),
    ...internetMapGetters({
      internetApplyDetail: internetTypes.INTERNET_COMMERCE_APPLY_DETAIL,
    }),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
    toCurrency(val) {
      return util.toCurrency(val);
    },
    formData() {
      var supportData = '';

      if (this.internetCommerceApply.cashSupport > 0) {
        supportData = `${this.internetCommerceApply.cashSupport
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원 현금`;
        if (
          this.internetCommerceApply.giftCardSupport == 0 &&
          this.internetCommerceApply.giftItemSupport == 0
        ) {
          supportData += ' 지원';
        }
      }

      if (this.internetCommerceApply.giftCardSupport > 0) {
        if (this.internetCommerceApply.cashSupport > 0) {
          supportData +=
            ' + ' +
            this.internetCommerceApply.giftCardSupport
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            '원 상품권';
        }

        if (this.internetCommerceApply.giftItemSupport == 0) {
          supportData += ' 지원';
        }
      }

      if (this.internetCommerceApply.giftItemSupport > 0) {
        if (
          this.internetCommerceApply.cashSupport > 0 ||
          this.internetCommerceApply.giftCardSupport > 0
        ) {
          supportData +=
            ' + ' +
            this.internetCommerceApply.giftItemSupport
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ',') +
            '원 사은품 지원';
        }
      }

      let data = [];

      let internetTv = '';
      if (this.internetCommerceApply.itemInternet) {
        internetTv += `[인터넷] ${this.internetCommerceApply.itemInternet}`;
      }
      if (this.internetCommerceApply.itemTv) {
        internetTv += ` / [TV] ${this.internetCommerceApply.itemTv}`;
      }
      // 개인정보
      if (this.isPromotionView) {
        data.push(
          `* 매장정보 : ${this.shopName}`,
          `* 가입상품정보 : ${this.internetCommerceApply.item}`,
          `* 고객성함 : ${this.form.name}`,
          `* 주민번호 : ${this.form.residentNumber}`,
          `* 통신사 : ${this.form.mobileTelecom}`,
          `* 휴대폰번호 : ${this.form.mobileNumber}`,
          `* 설치주소 : ${this.form.address} ${this.form.addressDetail}`,
          `* 희망설치일 : ${this.form.installDate}`,
          `* 이메일 : ${this.form.email}`,
        );
      } else {
        data.push(
          `* 매장정보 : ${this.shopName}`,
          `* 가입상품정보 : ${this.internetCommerceApply.item}`,
          `* 지원내역 : ${supportData}`,
          `* 고객성함 : ${this.form.name}`,
          `* 주민번호 : ${this.form.residentNumber}`,
          `* 휴대폰번호 : ${this.form.mobileNumber}`,
          `* 설치주소 : ${this.form.address} ${this.form.addressDetail}`,
          `* 희망설치일 : ${this.form.installDate}`,
          `* 이메일 : ${this.form.email}`,
        );
      }

      if (internetTv) {
        data.splice(2, 0, `* 가입요금정보 : ${internetTv}`);
      }
      // 요금납부 정보
      if (this.payType === 'CARD') {
        data.push(
          `* 카드사 : ${this.form.cardName}`,
          `* 카드주 : ${this.form.cardOwner}`,
          `* 카드번호 : ${this.form.cardNumber}`,
          `* 카드유효기간 : ${this.form.cardMonth}/${this.form.cardYear}`,
        );
      } else {
        data.push(
          `* 예금주명 : ${this.form.bankOwner}`,
          `* 은행명 : ${this.form.bankName}`,
          `* 계좌번호 : ${this.form.bankNumber}`,
        );
      }
      if (!this.isPromotionView) {
        // 입금정보
        data.push(
          `* 예금주명 : ${this.form.supportBankName}`,
          `* 은행명 : ${this.form.supportBankOwner}`,
          `* 계좌번호 : ${this.form.supportBankNumber}`,
        );
      } else {
        data.push(`* 상품권 : ${this.form.giftOption}`);
      }

      var sData = data.join('\n');
      return sData;
    },
  },
  watch: {
    hideInfo(val) {
      if (val) {
        this.maskingFields();
      } else {
        this.form = this.internetApplyDetail.detail;
      }
    },
    isSameInfo(val) {
      if (val) {
        this.form.supportBankName = this.form.bankName;
        this.form.supportBankOwner = this.form.bankOwner;
        this.form.supportBankNumber = this.form.bankNumber;
      }
    },
  },
  beforeDestroy() {
    this[commonActions.SET_CUSTOM_HEADER_TEXT](undefined);
  },
  async created() {
    /**
     * applyMode
     * form : 사장님이 사용자한테 견적 보낸 후 진입 시
     * submit: 사용자가 가입신청서 작성할 때
     * detail: 그 외의 사용자, 사장님이 진입할 때 모든 상태
     */
    console.log('this.$route.params');
    console.log(this.$route.params);
    if (this.applyMode == undefined) {
      this.$router.go(-1);
      return;
    }

    if (this.applyMode == 'submit' || this.applyMode == 'detail') {
      await this.getMyProfile();
      await this.getInternetApply();
      await this.getStoreInfo(this.internetApplyDetail.storeId);

      this.storeId = this.internetApplyDetail.storeId;

      this.internetCommerceApply.telecom = this.internetApplyDetail.telecom;
      this.internetCommerceApply.item = this.internetApplyDetail.item;
      this.internetCommerceApply.monthPrice = this.internetApplyDetail.monthPrice;
      this.internetCommerceApply.cashSupport = this.internetApplyDetail.cashSupport;
      this.internetCommerceApply.giftCardSupport = this.internetApplyDetail.giftCardSupport;
      this.internetCommerceApply.giftItemSupport = this.internetApplyDetail.giftItemSupport;
      this.internetCommerceApply.phoneTogether = this.internetApplyDetail.phoneTogether;
      this.internetCommerceApply.memoSupport = this.internetApplyDetail.requirement;
      this.internetCommerceApply.perceSupport = this.internetApplyDetail.perceSupport;
      this.internetCommerceApply.itemTv = this.internetApplyDetail.itemTv;

      this.internetCommerceApply.itemInternet = this.internetApplyDetail.itemInternet;
      this.internetCommerceApply.promotionId = this.internetApplyDetail.promotionId;

      this.internetCommerceApply.cashRewardDate = this.internetApplyDetail.cashRewardDate;
      this.internetCommerceApply.giftcardSendDate = this.internetApplyDetail.giftcardSendDate;
      this.internetCommerceApply.contractMonth = this.internetApplyDetail.contractMonth;
      this.internetCommerceApply.usageMonth = this.internetApplyDetail.usageMonth;
      this.internetCommerceApply.installCost = this.internetApplyDetail.installCost;
      this.internetCommerceApply.installCostWeekend = this.internetApplyDetail.installCostWeekend;
      this.internetCommerceApply.channel = this.internetApplyDetail.channel;
      this.internetCommerceApply.speed = this.internetApplyDetail.itemSpeed;

      console.log('this.internetApplyDetail');
      console.log(this.internetApplyDetail);

      if (this.internetApplyDetail.detail) {
        this.payType = this.internetApplyDetail.detail.paymentMethod;
        this.form = { ...this.internetApplyDetail.detail };

        console.log('this.form');
        console.log(this.form);

        const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
        const createdAt = new Date(this.internetApplyDetail.detail.createdAt);

        const sDays = format(
          new Date(createdAt.setDate(createdAt.getDate() + 15)),
          'yyyy-MM-dd HH:mm:ss',
        );

        if (now > sDays) {
          this.isSubmitDetail = false;
        } else {
          this.isSubmitDetail = true;
        }

        this.createDate = format(
          parseISO(this.internetApplyDetail.detail.createdAt),
          'yyyy-MM-dd',
        );
      }

      if (this.applyMode == 'submit') {
        this.disabled = false;
        this.readonly = true;
        this[commonActions.SET_CUSTOM_HEADER_TEXT]('인터넷 가입 신청서 보내기');
      } else if (this.applyMode == 'detail') {
        this.disabled = true;
        let title = '인터넷 가입 신청서';
        if (this.$route.params.icqId) title = '퍼스 인터넷 견적서';
        this[commonActions.SET_CUSTOM_HEADER_TEXT](title);
      }

      this.isSubmit = this.internetApplyDetail.submit == '1' ? true : false;
      if (this.isSubmit) this.disabled = true;
    }

    // KT 프로모션 4485
    // if (this.storeId == 3067) {
    if (this.storeId == 4485) {
      this.isPromotionView = true;
    }

    this.shopName = this.shop.name;
    this.shopTelNumber = this.shop.telNumber;
    this.shopAddress = this.shop.address;

    if (this.hideInfo) {
      this.maskingFields();
      if (this.applyId > 0) {
        this.getVoucherCnt();
      }
    }

    if (this.applyMode == 'detail') {
      if (this.applyId > 0) {
        this.getVoucherCnt();
      }
    }

    this.isCompleted = true;
  },
  updated() {
    // 주소 textarea 높이 설정
    if (!this.hideView && this.isSubmitDetail) {
      this.handelTextareaHeight();
    }
  },
  methods: {
    ...commonMapActions([commonActions.SET_CUSTOM_HEADER_TEXT]),
    ...userMapActions([userTypes.FETCH_ME]),
    ...shopMapActions([
      shopTypes.FETCH_SHOP,
      shopTypes.FETCH_SHOP_VOUCHERS_USE,
    ]),
    ...internetMapActions([
      internetTypes.CREATE_INTERNET_COMMERCE_APPLY,
      internetTypes.SELECT_INTERNET_COMMERCE_APPLY_DETAIL,
      internetTypes.CREATE_INTERNET_COMMERCE_APPLY_SUBMIT,
      internetTypes.SELECT_INTERNET_APPLY_CHECK_LIMIT,
      internetTypes.SELECT_INTERNET_APPLY_VALIDATE,
      internetTypes.SELECT_INTERNET_APPLY_CHECK_VALIDATE,
      internetTypes.SET_INTERNET_APPLY_CANCEL,
    ]),
    ...chatMapActions([
      // chatTypes.FETCH_CHATROOM_CHECK_LIMIT,
      chatTypes.MESSAGE_NOTICE,
    ]),
    async getMyProfile() {
      await this[userTypes.FETCH_ME]();
      console.log('getMyProfile');
      console.log(this.user);
    },
    async getStoreInfo(storeId) {
      await this[shopTypes.FETCH_SHOP]({ id: storeId });
    },
    applyCk() {
      const checkbox = document.getElementById('agree_checkbox');
      this.applyChecked = checkbox.checked;
    },
    validationCheck() {
      console.log('this.$v');
      console.log(this.$v);
      this.$v.$touch(); // validate 라이브러리 사용 https://yeongseungjeong.tistory.com/62
      const validKeys = Object.keys(this.$v.form);
      let isStop = false;
      isStop = true;
      validKeys.forEach(item => {
        if (this.$v.form[item].$error && isStop) {
          this.$refs[item].focus();
          isStop = false;
        }
      });
      return isStop;
    },
    async sendForm() {
      if (this.applyMode == 'submit') {
        const valid = this.validationCheck();
        if (!valid) return;
        // 동의 확인
        if (!this.applyChecked) {
          this.message = '개인정보 제공 동의가 필요합니다.';
          this.toastView();
          return;
        }

        // 동일 견적 요청서의 동일 명의로 신청 내역이 있는지 확인
        await this[internetTypes.SELECT_INTERNET_APPLY_VALIDATE]({
          name: this.form.name,
          mobileNumber: this.form.mobileNumber,
        }).then(res => {
          const applyCnt = res.applyCnt;
          const applyList = res.applyList;
          if (applyCnt > 0) {
            this.dupList = applyList;
            this.cusDupPopup = true;
          } else {
            this.applyPopup = true;
          }
        });
      }
    },
    async cusDupPopupClose(checked) {
      if (checked) {
        this.applyPopup = true;
      }
      this.cusDupPopup = false;
    },
    async applyPopupClose(checked) {
      if (checked) {
        if (this.applyMode == 'submit') {
          // 신청서 보내기
          let params = { ...this.form };
          params.icqId = this.internetApplyDetail.icId;
          params.isSendChatMessage = true; // 알림톡
          params.paymentMethod = this.payType;

          // 값 초기화
          if (this.payType === 'CARD') {
            params.bankOwner = '';
            params.bankName = '';
            params.bankNumber = '';
          } else {
            params.cardName = '';
            params.cardOwner = '';
            params.cardNumber = '';
            params.cardYear = '';
          }

          if (!this.isPromotionView) {
            params.mobileTelecom = '';
            params.giftOption = '';
          }

          params.installDate = format(params.installDate, 'yyyy-MM-dd');

          console.log('paramsparamsparamsparams');
          console.log(params);

          await this[internetTypes.CREATE_INTERNET_COMMERCE_APPLY_SUBMIT](
            params,
          ).then(() => {
            if (this.isPromotionView) {
              util.sdk_logEvent('INTERNET_PROMOTION_APPLY', {
                promotionCode: 'KT2408',
                telecom: 'KT',
                user_id: this.user.id,
                icq_id: this.internetApplyDetail.icId,
                user_nickname: this.user.nickname,
              });
              util.sdk_logEventKakao('INTERNET_PROMOTION_KT_APPLY');
            } else {
              util.sdk_logEvent('INTERNET_APPLY', {
                user_id: this.user.id,
                icq_id: this.internetApplyDetail.icId,
              });
              util.sdk_logEventKakao('INTERNET_APPLY');
            }
            this.$router.go(-1);
          });
        }
      }
      this.applyPopup = false;
    },
    addressSearch() {
      this.$refs.addressSearch.isOpen = true;
      this.$refs.addressSearch.list = [];
      this.$refs.addressSearch.direction = 'top';
      this.$refs.addressSearch.infiniteId = 0;
      this.$refs.addressSearch.searchText = '';
      this.$refs.addressSearch.searchResultText = '';
      this.$router.push({
        name: 'InternetCommerce.ApplyForm',
        params: this.$route.params,
        hash: '#address',
      });
    },
    async closeAddressSearch() {
      await this.$refs.addressSearch.$refs.dummy2.scrollIntoView({
        behavior: 'smooth',
      });

      this.jibunAddr = this.$refs.addressSearch.jibunAddr;
      this.form.address = this.$refs.addressSearch.roadAddr;
      this.$refs.addressSearch.isOpen = false;

      this.handelTextareaHeight();

      await sleep(100);

      this.$router.go(-1);
    },
    toastView() {
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    async getInternetApply() {
      let id = this.applyId;
      if (this.$route.params.icqId) id = this.$route.params.icqId;

      if (id) {
        let params = {
          id: id,
          applyMode: this.applyMode,
          applyType: this.applyType,
        };

        await this[internetTypes.SELECT_INTERNET_COMMERCE_APPLY_DETAIL](params);
      }
    },
    maskingFields() {
      for (const [key, value] of Object.entries(this.form)) {
        if (value) {
          if (key !== 'address' && key !== 'addressDetail') {
            if (key === 'name') {
              this.form.name = setMaskingFirst(value);
            } else {
              this.form[key] = setMasking(value);
            }
          }
        }
      }
    },
    copyForm() {
      const copyText = document.getElementById('apply_form');
      copyText.select();
      document.execCommand('copy');
      this.message = '복사 되었습니다.';
      this.toastView();
    },
    async dupCheckInfo() {
      // 동일 견적 요청서의 동일 명의로 신청 내역이 있는지 확인
      await this[internetTypes.SELECT_INTERNET_APPLY_CHECK_VALIDATE]({
        applyId: this.applyId,
      }).then(res => {
        const applyCnt = res.applyCnt;
        const applyList = res.applyList;
        if (applyCnt > 0) {
          this.dupList = applyList;
          this.ownerDupPopup = true;
        } else {
          this.checkInfo();
        }
      });
    },
    ownerDupPopupClose(checked) {
      if (checked) {
        this.checkInfo();
      }
      this.ownerDupPopup = false;
    },
    checkInfo() {
      console.log('apply_____openInternetApplyVoucher');
      this.$refs.internetApplyVoucher.applyId = this.applyId;
      this.$refs.internetApplyVoucher.isOpen = true;
      setTimeout(() => {
        this.$refs.internetApplyVoucher.$refs.modal_close.style.display =
          'block';
      }, 100);
    },
    closeInternetApplyVoucherModal() {
      this.$refs.internetApplyVoucher.$refs.modal_close.style.display = 'none';
      this.$refs.internetApplyVoucher.isOpen = false;
    },
    async voucherUse() {
      if (this.applyId > 0) {
        if (this.userApplyCancel) {
          this.customerApplyCancelNoPopupOpen();
        } else {
          try {
            this[shopTypes.FETCH_SHOP_VOUCHERS_USE]({
              applyId: this.applyId,
            })
              .then(() => {
                // 성공
                if (this.vouchersUseResult.resultCd == 'S') {
                  console.log('바우처 사용 성공');
                  // 시스템 메세지 추가
                  this.createVoucherSystemMessage();
                  this.closeInternetApplyVoucherModal();

                  this.getInternetApply().then(() => {
                    this.hideInfo = false;
                  });
                } else {
                  console.log('바우처 사용 실패');
                  this.msgPopup = this.vouchersUseResult.resultMsg;
                }
              })
              .catch(() => {
                console.log('error');
              });
          } catch (e) {
            console.log('error');
          }
        }
      }
    },
    customerApplyCancelNoPopupOpen() {
      this.customerApplyCancelNoPopup = true;
    },
    customerApplyCancelNoPopupClose() {
      this.customerApplyCancelNoPopup = false;
      this.$router.go(-1);
    },
    async createVoucherSystemMessage() {
      let sendType = 'internetVoucherOpenNotice';
      // KT 프로모션 4485
      if (this.isPromotionView) {
        sendType = 'internetPromotionKT2408OpenNotice';
      }
      const params = {
        userId: this.userId,
        storeId: this.storeId,
        sendType: sendType,
      };

      this[chatTypes.MESSAGE_NOTICE](params);
    },
    async getVoucherCnt() {
      var shopVouchers = await this[
        internetTypes.SELECT_INTERNET_APPLY_CHECK_LIMIT
      ]({
        applyId: this.applyId,
      });

      console.log('shopVouchers');
      console.log(shopVouchers);

      this.shopVouchersCnt = shopVouchers.voucherCnt;
      this.shopVouchersLimit = shopVouchers.limit;
      this.userApplyCancel = shopVouchers.cancel;
    },
    openMonthModal() {
      if (this.disabled) return;
      this.isMonthModal = true;
    },
    closeMonthModal(dataType, val) {
      if (dataType) {
        this.form.cardMonth = val;
      }
      this.isMonthModal = false;
    },
    openYearModal() {
      if (this.disabled) return;
      this.isYearModal = true;
    },
    closeYearModal(dataType, val) {
      if (dataType) {
        this.form.cardYear = val;
      }
      this.isYearModal = false;
    },
    openTelecomModal() {
      if (this.disabled) return;
      this.isTelecomModal = true;
    },
    closeTelecomModal(dataType, val) {
      if (dataType) {
        this.form.mobileTelecom = val;
      }
      this.isTelecomModal = false;
    },
    handleCardNumber(evt) {
      this.form.cardNumber = util.cardNumberFormatter(
        evt.data,
        evt.target.value,
      );
    },
    handleNumberInput(value) {
      this.form[value] = util.numberFormatter(this.form[value]);
    },
    handelTextareaHeight() {
      const textarea = this.$refs.address;
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 2 + 'px';
    },
    customerApplyCancelPopupOpen() {
      this.customerApplyCancelPopup = true;
    },
    customerApplyCancelPopupClose(checked) {
      if (checked) {
        this.setUserApplyCancel(this.applyId);
      }
      this.customerApplyCancelPopup = false;
    },
    setUserApplyCancel(applyId) {
      this[internetTypes.SET_INTERNET_APPLY_CANCEL]({
        id: applyId,
      }).then(res => {
        console.log('setUserApplyCancel');
        console.log(res);
        if (res.resultCd == 'SUCCESS') {
          this.$router.go(-1);
        } else if (res.resultCd == 'VIEWED') {
          this.alreadyVoucherOpenPopupOpen();
        } else {
          alert('취소 실패');
          this.$router.go(-1);
        }
      });
    },
    alreadyVoucherOpenPopupOpen() {
      this.alreadyVoucherOpenPopup = true;
    },
    alreadyVoucherOpenPopupClose() {
      this.alreadyVoucherOpenPopup = false;
      this.$router.go(-1);
    },
  },
  validations: {
    form: {
      name: { required },
      residentNumber: {
        test(val) {
          val = val.trim();
          if (!val) {
            this.errorMessage.residentNumber = '주민번호를 입력해 주세요';
            return false;
          }
          const regex = /^([0-9]{13})$/;
          if (!regex.test(val)) {
            this.errorMessage.residentNumber =
              '주민번호(13자리)를 확인해 주세요';
            return false;
          }
          return true;
        },
      },
      mobileNumber: {
        test(val) {
          val = val.trim();
          if (!val) {
            this.errorMessage.mobileNumber = '휴대폰 번호를 입력해 주세요';
            return false;
          }
          const regex = /^010|011|016|017|018|019|999\d{3,4}\d{4}$/;
          if (!regex.test(val) || (val.length != 10 && val.length != 11)) {
            this.errorMessage.mobileNumber =
              '휴대폰 번호를 정확히 입력해 주세요';
            return false;
          }
          return true;
        },
      },
      address: { required },
      email: {
        test(val) {
          if (!this.isPromotionView) {
            if (!val) {
              this.errorMessage.email = '이메일을 입력해 주세요';
              return false;
            }
          }
          if (val && !util.emailFormatter(val)) {
            this.errorMessage.email = '이메일을 확인해 주세요';
            return false;
          }
          return true;
        },
      },
      cardName: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      cardOwner: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            this.errorMessage.cardOwner = '카드주명을 입력해 주세요';
            return false;
          }
          if (this.payType === 'CARD' && val != this.form.name) {
            this.errorMessage.cardOwner =
              '인터넷 명의자와 납부자가 일치해야 합니다';
            return false;
          }
          return true;
        },
      },
      cardNumber: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      cardMonth: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      cardYear: {
        test(val) {
          if (this.payType === 'CARD' && !val) {
            return false;
          }
          return true;
        },
      },
      bankOwner: {
        test(val) {
          if (this.payType === 'BANK' && !val) {
            this.errorMessage.bankOwner = '예금주명을 입력해 주세요';
            return false;
          }

          if (this.payType === 'BANK' && val != this.form.name) {
            this.errorMessage.bankOwner =
              '인터넷 명의자와 납부자가 일치해야 합니다';
            return false;
          }
          return true;
        },
      },
      bankName: {
        test(val) {
          if (this.payType === 'BANK' && !val) {
            return false;
          }
          return true;
        },
      },
      bankNumber: {
        test(val) {
          if (this.payType === 'BANK' && !val) {
            return false;
          }
          return true;
        },
      },
      mobileTelecom: {
        test(val) {
          val = val.trim();
          if (!val && this.isPromotionView) {
            this.errorMessage.mobileTelecom = '통신사를 선택해 주세요';
            return false;
          }
          return true;
        },
      },
      installDate: {
        test(val) {
          if (!val) {
            this.errorMessage.installDate = '희망 설치일을 선택해 주세요';
            return false;
          }
          return true;
        },
      },
      supportBankOwner: {
        test(val) {
          if (!val && !this.isPromotionView) {
            this.errorMessage.supportBankOwner = '예금주명을 입력해 주세요';
            return false;
          }
          return true;
        },
      },
      supportBankName: {
        test(val) {
          if (!val && !this.isPromotionView) {
            this.errorMessage.supportBankName = '은행명을 입력해 주세요';
            return false;
          }
          return true;
        },
      },
      supportBankNumber: {
        test(val) {
          if (!val && !this.isPromotionView) {
            this.errorMessage.supportBankNumber = '계좌번호를 입력해 주세요';
            return false;
          }
          return true;
        },
      },
      // giftOption: { required },
    },
    setDate() {
      // console.log(this.form.installDate);
      // const installDate = this.form.installDate;
      // var week = new Array(
      //   '일요일',
      //   '월요일',
      //   '화요일',
      //   '수요일',
      //   '목요일',
      //   '금요일',
      //   '토요일',
      // ); // 7, 1, 2, 3, 4, 5, 6
      // const iDate = new Date(installDate.setDate(installDate.getDate()));
      // this.form.installDate =
      //   format(iDate, 'MM월 dd일') + ' (' + week[iDate.getDay()] + ')';
      // console.log(this.form.installDate);
    },
  },
};
</script>
